import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import SuppliersList from "./SuppliersList";
import styles from "../Settings.module.scss";
import EditSupplierCategory from "./EditSupplierCategory";
import { toast } from "react-toastify";
import {
  addSupplierCategory,
  getSupplierCategories,
  updateSupplierCategory,
} from "../../../services/supplierCategoryService";

const SupplierCategories = (props) => {
  const [showForm, setShowForm] = React.useState(false);
  const [editItem, setEditItem] = React.useState();
  const [loading, setLoading] = React.useState(true);
  const [supplierCategories, setSupplierCategories] = React.useState([]);

  const closeForm = () => {
    setShowForm(false);
    if (editItem) setEditItem();
  };

  const fetchData = async () => {
    setLoading(true);
    const data = await getSupplierCategories();
    setSupplierCategories(data);
    setLoading(false);
  };

  const enterEdit = (item) => {
    if (!item?.id) {
      console.error("Missing item.id for edit:", item);
      return;
    }
    setShowForm(true);
    setEditItem(item);
  };

  const handleSubmit = async (formData) => {
    try {
      if (editItem) {
        await updateSupplierCategory(formData.id, formData);
        toast.success("Supplier Category Updated");
        setEditItem();
      } else {
        await addSupplierCategory(formData);
        toast.success("Supplier Category Added");
      }
      closeForm();
      await fetchData();
    } catch (error) {
      console.error(error);
      toast.error("Error occurred while adding Supplier Category");
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <div className="d-flex flex-column">
        <div className="d-flex ms-auto mt-5 me-5">
          <Button
            className={`common-btn ${styles.button} me-5`}
            onClick={() => {
              setShowForm(true);
              props.open?.();
            }}
          >
            Add Supplier Category
          </Button>
        </div>

        <div className="row mx-auto mt-3 col-12 col-xl-9 col-xxl-6">
          <SuppliersList
            supplierCategories={supplierCategories}
            loading={loading}
            enterEdit={enterEdit}
          />
        </div>
      </div>

      {showForm && (
        <EditSupplierCategory
          cancelEdit={closeForm}
          onSubmit={handleSubmit}
          editItem={editItem}
        />
      )}
    </React.Fragment>
  );
};

export default SupplierCategories;
